import React from 'react';
import ClassNames from 'classnames';
import { useSelector } from 'react-redux';
import { Icon } from '@pwc/pwc-deals-ui';
import { getIsDarkModeSelector } from '../../redux/userSettings/userSettingsSlice';
import styles from './CalloutBox.module.scss';

const CalloutBoxContainer = ({
  iconName,
  iconClass = 'icon fill icon-grey-theme',
  headerLabel,
  dataTestId,
  usage,
  children,
  ignore,
  onClick,
}) => {
  if (ignore) return children;

  /* eslint-disable-next-line react-hooks/rules-of-hooks */
  const darkMode = useSelector(getIsDarkModeSelector);

  return (
    <div
      className={ClassNames(
        styles['callout-box'],
        darkMode
          ? styles['callout-box--dark-theme']
          : styles['callout-box--light-theme'],
        usage === 'summary' ? styles['callout-box--summary'] : undefined,
        usage === 'detail' ? styles['callout-box--detail'] : undefined
      )}
      data-testid={dataTestId}
      onClick={onClick}
      onKeyDown={() => null}
      role="button"
      tabIndex={0}
    >
      <div className={styles['callout-box__header']}>
        <Icon name={iconName} className={iconClass} width={18} height={18} />
        <span aria-label={headerLabel}>{headerLabel}</span>
      </div>
      {children}
    </div>
  );
};

export default CalloutBoxContainer;
